import { render, staticRenderFns } from "./DialogMessageType.vue?vue&type=template&id=75253e0e"
import script from "./DialogMessageType.vue?vue&type=script&lang=js"
export * from "./DialogMessageType.vue?vue&type=script&lang=js"
import style0 from "./DialogMessageType.vue?vue&type=style&index=0&id=75253e0e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75253e0e')) {
      api.createRecord('75253e0e', component.options)
    } else {
      api.reload('75253e0e', component.options)
    }
    module.hot.accept("./DialogMessageType.vue?vue&type=template&id=75253e0e", function () {
      api.rerender('75253e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogMessageType.vue"
export default component.exports